import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import { Prop, Watch } from 'vue-property-decorator';
import { judgeDeviceType } from '@/utils/device';
import { toAppMember } from '@/utils/utils';
@Component({
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class wordLimitPopup extends Vue {
  @Prop({default: true})
  visible: boolean;
  @Prop({default: []})
  freeWordLevelList: number[]; // 免费会员预设的字数选项
  @Prop({default: []})
  normalLevelList: number[]; // 会员预设的字数选项
  @Prop({default: {}})
  vipInfo: any;
  @Prop({default: 0})
  limitWordNum: number;
  @Prop({default: 1000})
  singleLength: number;
  @Prop({default: false})
  isNovel: boolean; // 是否是小说推广过来的
  state = new PageState();
  show = false

  isApp = judgeDeviceType.isAPP

  currentLimitWord = 0  
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  @Watch('visible')
  listenVisible(val) {
    this.show = val
    if (val) {
      this.currentLimitWord = this.limitWordNum
    }
  }
  closePopup() {
    this.show = false
    this.$emit('close')
  }
  /**
   * 选择当前字数
   * @param item
   */
  selectWordLevel(item) {
    if (this.isNovel) {
      this.currentLimitWord = item
      return
    }
    if (this.vipInfo.vipType !== 1) return
    this.currentLimitWord = item
  }
  /**
   * 确定字数选择
   * @param word
   */
  confirmWord() {
    this.$emit('change-limit-word', this.currentLimitWord)
  }
  /**
   * 跳转会员中心
   */
  doToMember() {
    if (this.isApp) {
      toAppMember()
    } else {
      this.$navigateTo({
        url: '/mine-package/pages/recharge-vip/recharge-vip'
      })
    }
    
  }
}